import React from "react";

type CompanyInfo = {
  about: string;
  address: string;
  email: string;
  phone: string;
  location: string;
  employees: number;
  branches: number;
  joined: string;
  userId: string;
  vehicles: string[];
  services: string[];
  operationDays: string;
  operationHours: string;
};

const InfoItem = ({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) => (
  <div>
    <p className="text-sm font-bold text-[#00032A]">{label}</p>
    <p className="text-sm text-[#4F4F4F]">{value}</p>
  </div>
);

interface CompanyDetailsCardProps {
  company: CompanyInfo;
}

export const CompanyDetailsCard: React.FC<CompanyDetailsCardProps> = ({
  company,
}) => {
  return (
    <div className="w-full relative">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InfoItem label="About" value={company.about} />
        <InfoItem label="Phone" value={company.phone} />

        <InfoItem label="Address" value={company.address} />
        <InfoItem label="User ID" value={company.userId} />

        <InfoItem label="Email" value={company.email} />
        <InfoItem label="Vehicles" value={company.vehicles.join(", ")} />

        <InfoItem label="Location" value={company.location} />
        <InfoItem label="Services" value={company.services.join(", ")} />

        <InfoItem label="Employees" value={company.employees} />
        <InfoItem
          label="Operation hours"
          value={`${company.operationDays} — ${company.operationHours}`}
        />

        <InfoItem label="Branches" value={company.branches} />
        <InfoItem label="Joined" value={`Member since ${company.joined}`} />
      </div>
    </div>
  );
};
